import { render, staticRenderFns } from "./PositiveInfections.vue?vue&type=template&id=febc1352&"
import script from "./PositiveInfections.vue?vue&type=script&lang=js&"
export * from "./PositiveInfections.vue?vue&type=script&lang=js&"
import style0 from "./PositiveInfections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports